<template>
  <va-autocomplete-input
    :value="value"
    required
    itemText="name"
    itemValue="value"
    :label="label"
    :choices="items"
    cache-items
    @input="updateTimezone"
    :min-chars="1"></va-autocomplete-input>
</template>

<script>
  import { default as timezonesList } from "../../assets/data/timezones/timezones.json";
  import { onMounted } from "@vue/composition-api";

  export default {
    name: "TimezonePicker",
    props: {
      value: {
        type: String,
        default: "",
      },
      label: {
        type: String,
        default: "",
      },
      required: {
        type: Boolean,
        default: false,
      },
      preselectSuggested: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, { emit }) {
      const items = timezonesList;

      let suggestedTimezone = "";

      try {
        suggestedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (e) {
        console.error(e);
      }

      onMounted(() => {
        if (props.preselectSuggested) updateTimezone(suggestedTimezone);
      });

      const updateTimezone = value => {
        emit("input", value);
      };

      return { updateTimezone, items, suggestedTimezone };
    },
  };
</script>
